exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide-div{\r\n    display: none;\r\n}\r\npagination{\r\n    z-index: 99999;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/product-list-grid/product-list-grid.component.css
// module id = ../../../../../src/app/container/products-and-filter/product-list-grid/product-list-grid.component.css
// module chunks = main